import React from 'react'
import {useSelector} from 'react-redux'

import {Loader} from 'components/UI/Loader/Loader'

import {ISystemState} from 'model/system/systemReducer'


// Type
export type typeDataPageDashboard = {}


// Component
export const DataPageDashboard: React.FC<typeDataPageDashboard> = ({children}) => {

    const dashboardLoader = useSelector((state:{system: ISystemState}) =>state.system.dashboardLoader)

    return(
        <div className="relative">

            <div className="flex flex-col">
                <div className="-my-2">
                    <div className="py-2 align-middle inline-block min-w-full">
                        {children}
                    </div>
                </div>
            </div>

            {dashboardLoader ? <Loader/> : null}

        </div>
    )
}